import React from 'react';

import EmailLinkWithSubjectAndBody from '../components/common/Form/EmailLinkWithSubjectAndBody';

const uploadErrorInformation = ({source, accountManagerEmail, leadId, failedUploads=[]}) => {
  return (
    [
      'Your application was submitted but the following document(s) failed. ',
      <EmailLinkWithSubjectAndBody
        key="AccountManagerEmail"
        email={accountManagerEmail}
        emailSubject={`Failed Document Upload - ${source}`}
        emailBody={[
          `Reference #: ${leadId}`,
          'The following documents failed to upload:',
          failedUploads.join('\n'),
        ]}
        message="Please email these document(s) to your "
      />
    ]
  );
};

export { uploadErrorInformation };

